import Component from "@glimmer/component";
import { service } from "@ember/service";
import DToast from "float-kit/components/d-toast";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
export default class DToasts extends Component {
  static {
    dt7948.g(this.prototype, "toasts", [service]);
  }
  #toasts = (dt7948.i(this, "toasts"), void 0);
  static {
    setComponentTemplate(precompileTemplate("\n    <section class=\"fk-d-toasts\">\n      {{#each this.toasts.activeToasts as |toast|}}\n        <DToast @toast={{toast}} />\n      {{/each}}\n    </section>\n  ", {
      strictMode: true,
      scope: () => ({
        DToast
      })
    }), this);
  }
}